import React from "react";
import {useState} from "react";

import {useNavigate} from "react-router-dom";
import {isEmail} from "../../../helpers/string";
import {getImageUrl} from "../../../utils/images";
import {Footer, MobileFooter} from "../../../layout/Footer/Footer";
import {onEnterPressed} from "../../../helpers/events";
import {sendpasswordresetlink} from "../../../service/onboardingService";
import {showMessage} from "../../../utils/alerts";
import {showMessageCustom} from "../../../utils/alertwithcustomfunc";

export const ForgotPassword = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [errorText, setErrorText] = useState("");
    const [emailErrorText, setEmailErrorText] = useState("");

    const [passwordErrorText, setPasswordErrorText] = useState("");

    const [isInvalidEmail, setIsInvalidEmail] = useState(true);

    const [isPasswordEmpty, setIsPasswordEmpty] = useState(true);

    const [isChecking, setIsChecking] = useState(false);

    const sendLinktoEmail = async () => {
        if (!(Object.keys(localStorage).length === 0)) {
            localStorage.clear();
        }
        if (isEmail(email)) {
            setIsChecking(true);
            const response = await sendpasswordresetlink(email);
            if (response?.data.status === 200) {
                showMessage(
                    "Verification code sent!",
                    "Please enter it along with your new password to reset your password."
                );
                navigate("/forgot-password/entercode");

                // setIsOTPSent(true)
                setIsChecking(false);

                return;
            } else if (response?.data.status === 200 && response?.data.message === "no.user.exists") {
                showMessageCustom(
                    "Email address not found",
                    "The user with this email does not exist. Please check the email address or register for a new account."
                );
                setIsChecking(false);
                return;
            }
        } else {
            email === ""
                ? setEmailErrorText("Please enter your registered email address!")
                : setEmailErrorText("Invalid email!");
            setIsChecking(false);
        }
        setIsChecking(false);
    };

    const checkEmail = async (currentEmail) => {
        if (Object.keys(localStorage).length > 0) {
            localStorage.clear();
        }
        if (!isEmail(currentEmail)) {
            const errorMessage = currentEmail === "" ? "Please enter your registered email address!" : "Invalid email!";
            setEmailErrorText(errorMessage);

            return setIsInvalidEmail(true);
        }
        return setIsInvalidEmail(false);
    };

    const checkPassword = async (currentPassword) => {
        if (Object.keys(localStorage).length > 0) {
            localStorage.clear();
        }


        if (currentPassword === "") {
            setPasswordErrorText("Please enter Password!");

            return setIsPasswordEmpty(true);
        }

        return setIsPasswordEmpty(false);
    };

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-md-6 px-0">
                        <div className="pl-4 pl-md-50 pt-4">
                            <a href="#">
                                <img src={getImageUrl("logo-dark.svg")} alt="img" className="w-200p" />
                            </a>
                            <div className="pt-50 pb-4 d-none d-md-block">
                                <img src={getImageUrl("login-img.png")} alt="img" className="login-img" />
                            </div>
                            <p className="mb-0 font-26 mt-10 font-weight-800">Forgot password</p>
                            <p className="font-12">
                                Please provide your registered email address to receive an
                                <br />
                                verification code to reset your new password.
                            </p>
                            <Footer />
                        </div>
                    </div>
                    <div className="col-12 col-md-6 px-0">
                        <div className="login-right mobile-login">
                            <div>
                                {errorText && (
                                    <div className="d-flex position-fixed custom-margin justify-content-center mb-3">
                                        {" "}
                                        <label className="text-danger">{errorText}</label>
                                    </div>
                                )}

                                <div className="form-group">
                                    <label>Email address</label>
                                    <input
                                        type="text"
                                        value={email}
                                        maxLength={45}
                                        className="form-control"
                                        placeholder="Enter your email address"
                                        onKeyDown={(e) => onEnterPressed(e, checkEmail)}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            checkEmail(e.target.value);
                                        }}
                                        disabled={isChecking}
                                    />
                                    {isInvalidEmail && <label className="text-danger">{emailErrorText}</label>}
                                </div>

                              

                                <button
                                    type="button"
                                    className="btn btn-outline-light btn-block mb-3"
                                    onClick={sendLinktoEmail}
                                >
                                    {" "}
                                    {isChecking ? "Please wait" : "Submit"}
                                </button>
                                <div className="text-center backtologin">
                                    <img
                                        style={{filter: "invert(0.7)"}}
                                        src={getImageUrl("arrow-narrow-left.svg")}
                                        alt="img cursor-pointer"
                                        className="mr-5 left-arrow"
                                        onClick={() => {
                                            window.location.href = `${window.location.origin}/login-page`;
                                        }}
                                    />
                                    <a
                                        role="button"
                                        className="text-white cursor-pointer"
                                        onClick={() => {
                                            window.location.href = `${window.location.origin}/login-page`;
                                        }}
                                    >
                                        Back to login
                                    </a>
                                    <div
                                        className="mt-15 register-text text-center text-white"
                                        style={{minWidth: "max-content"}}
                                    >
                                        {/* <a role='button' className="text-white cursor-pointer" onClick={() => navigate("forgot-password")}
                  >Forgot Password?</a> */}
                                        <span className="opacity-70 mr-1">Don't have an account?</span>
                                        <a
                                            role="button"
                                            className="text-white cursor-pointer ml-5"
                                            onClick={() => {
                                                window.location.href = `${window.location.origin}/onboarding`;
                                            }}
                                        >
                                            <span className="font-weight-700">Register</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MobileFooter />
                </div>
            </div>
        </div>
    );
};
